import { Color, useColorBoard, useSetColor } from '../../../hooks/color';
import React, { useCallback } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { ColorLayer } from './ColorLayer';
export function Swatch(props) {
  var color = props.color;
  var baseColor = useColorBoard();
  var setColor = useSetColor();
  var currentColor = Color.fromRGBA(baseColor, {
    hasAlpha: true
  });
  var swatchColor = Color.fromString(color, {
    hasAlpha: true
  });
  var isEqual = currentColor.toHex8() === swatchColor.toHex8();
  var handleClick = useCallback(function () {
    setColor(color);
  }, [color]);
  var cls = usePrefixCls('color-swatch', {
    active: isEqual
  });
  var shadowStr = "rgba(0, 0, 0, 0.15) 0px 0px 0px 1px inset, ".concat(color, " 0px 0px 4px");
  return React.createElement("div", {
    className: cls,
    style: {
      boxShadow: isEqual ? shadowStr : undefined
    },
    onClick: handleClick
  }, React.createElement(ColorLayer, {
    type: "alpha"
  }), React.createElement(ColorLayer, {
    type: color
  }));
}